import { useStore } from "@nanostores/react"
import { useIsHydrated } from "shared/lib/react/useIsHydrated"

import { persistentAtom } from "@nanostores/persistent"

const sidebarExpandedAtomName = "sidebar-is-expanded"

const sidebarExpandedAtom = persistentAtom<boolean>(
  sidebarExpandedAtomName,
  true,
  {
    encode: value => (value === undefined ? "" : JSON.stringify(value)),
    decode: str => (str === "" ? undefined : JSON.parse(str))
  }
)

export function setPersistentSidebarExpanded(value: boolean): void {
  sidebarExpandedAtom.set(value)
}

export function usePersistentSidebarExpanded(): boolean | undefined {
  const isExpanded = useStore(sidebarExpandedAtom)
  const isHydrated = useIsHydrated()

  // The prerendered sidebar is always expanded. Applying the stored value
  // before hydration finished would leave stale classes in the DOM.
  return isHydrated ? isExpanded : true
}
